module.exports = "data:image/gif;base64,R0lGODlhCgAKALMAANfX16Ojo////+Dg4Onp6ebm5tra2uXl5efn5+Li4gAAAAAAAAAAAAAAAAAAAAAAACH5BAAAAAAALAAAAAAKAAoAAAQfkJASwgAYEHSqyEBxJIPwZdVQGaDngaVgmGBt33heRwA7"


/*****************
 ** WEBPACK FOOTER
 ** ./extjs/resources/themes/images/gray/sizer/se-handle.gif
 ** module id = 533
 ** module chunks = 0
 **/